module.exports = __webpack_public_path__ + "static/media/piston-3.3ab4a92a.mp3";